import {
  Spacing
} from 'UI'

export default {
  paperClass: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    padding: ({ padding }) => padding || Spacing(5),
    margin: ({ margin }) => margin || null
  },
  tagNameWrapper: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 8
  }
}
